// One of a fund's own broker accounts. Under a scope, every fund-page fetch computes as if the
// fund held only this account (spec 2026-10-29 account-scoped-fund-profile).
export interface AccountScope {
	brokerId: string;
	brokerAccountId: string;
}

export function sameScope(a: AccountScope | null, b: AccountScope | null): boolean {
	if (a === b) return true;
	if (!a || !b) return false;
	return a.brokerId === b.brokerId && a.brokerAccountId === b.brokerAccountId;
}

export function accountScopeKey(s: AccountScope): string {
	return `${s.brokerId}|${s.brokerAccountId}`;
}
